<template>
  <!-- A click target inside a card's or a row's link, so it stops the click before the link takes it -->
  <Badge
    :label="portfolio.name"
    icon="folder"
    variant="grey"
    size="small"
    role="button"
    tabindex="0"
    :aria-label="`Show only ${portfolio.name}`"
    class="portfolio-chip"
    @click.stop.prevent="emit('select', portfolio.id)"
    @keydown.enter.stop.prevent="emit('select', portfolio.id)"
    @keydown.space.stop.prevent="emit('select', portfolio.id)"
  />
</template>

<script setup lang="ts">
import { Badge } from '@tallo/design-system';

/** Where a unit or a building is filed; picking it narrows the properties page to that portfolio */
defineProps<{ portfolio: { id: string; name: string } }>();
const emit = defineEmits<{ select: [portfolioId: string] }>();
</script>

<style scoped lang="scss">
.portfolio-chip {
  cursor: pointer;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
    text-decoration-color: var(--t-color-border-primary);
  }
}
</style>
